import * as React from 'react';
import {useNavigate} from 'react-router-dom';
import Home from '../home/Home';
import {useUserInfo} from '../userInfo/hooks/useUserInfo';
import Dashboard from './Dashboard';
import './dashboard.css';
import {useAuthentication} from '../auth/hooks/useAuthentication';
import {AppBar} from "@mui/material";
import {useDarkMode} from "../darkMode/hook/useDarkMode";

function DashboardParent({setShowNav}) {
  const {profil} = useUserInfo();
  const nav = useNavigate();
  const {isAuthenticated, isLoading} = useAuthentication();
  const {mode} = useDarkMode();
  React.useEffect(() => {
    if (profil) {
      profil.subscriptionStatus !== 'active' && nav('/subscription-choice');
    }
  }, [profil?.subscriptionStatus]);

  if (isAuthenticated && !profil)
  return <AppBar
      sx={{
        backgroundColor: {
          xs: mode.settings.footerBackgroundColor,
          md: mode.settings.footerBackgroundColor,
          lg: mode.darkMode
              ? mode.settings.backgroundColor
              : isAuthenticated
                  ? '#F0F2F8'
                  : isLoading ? '#F0F2F8' : '#FFFFFF',
        },
        height : '95px',
        boxShadow : 'none !important'
      }}>
  </AppBar>;

  return profil && profil.subscriptionStatus == 'active' ? (
    <Dashboard setShowNav={setShowNav} />
  ) : (
    <Home setShowNav={setShowNav} />
  );
}

export default DashboardParent;
